import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
;
var VeltCommentsSidebarMinimalFilterDropdownContentFilterAll = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-filter-all-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarMinimalFilterDropdownContentFilterAll;
